module.exports = global["jQuery"] = require("-!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
// module id = 41
// module chunks = 0